'use client';

import { useState, useEffect, useRef } from 'react';
import Link from "next/link";
import { FaChevronDown } from "react-icons/fa";
import { HiOutlineBuildingOffice2, HiOutlineIdentification } from "react-icons/hi2";

export default function DealerDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const options = [
    {
      label: "مشاهده نمایندگی ها",
      href: "/dealers",
      icon: <HiOutlineBuildingOffice2 className="text-slate-700" />,
    },
    {
      label: "اخذ نمایندگی",
      href: "/dealerRegistration",
      icon: <HiOutlineIdentification className="text-slate-700" />,
    },
  ];

  return (
    <div className="relative inline-block text-right" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        type="button"
        className="flex items-center gap-1 text-[#313E75] hover:text-blue-600 transition-colors font-medium py-2"
      >
        <span>نمایندگی ها</span>
        <FaChevronDown 
          className={`h-3 w-3 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} 
        />
      </button>

      {isOpen && (
        <div className="absolute mt-2 w-56 bg-white border border-gray-200 rounded-xl shadow-xl z-[10000] overflow-hidden animate-in fade-in zoom-in duration-150 left-1/2 -translate-x-1/2 md:translate-x-0 md:right-0">
          <div className="py-1 flex flex-col">
            {options.map((option, index) => (
              <Link
                key={index}
                href={option.href}
                onClick={() => setIsOpen(false)}
                className="flex items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-colors border-b last:border-b-0 border-gray-50"
              >
                <span className="text-xl">{option.icon}</span>
                <span className="font-bold">{option.label}</span>
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}